import Vue from 'vue'
// import Vuetify from 'vuetify'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'
import 'moment/locale/ja'

import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './assets/app.scss'
import createAPI from './api'
import toast from './toast'
import vuetify from './plugins/vuetify'

Vue.use(InfiniteLoading, {
  /* options */
})
// Vue.use(Vuetify)
let api = createAPI(() => store.getters.token)
Vue.config.productionTip = false
Vue.prototype.$api = api
store.$api = api
Vue.use(toast)

Vue.filter('date', (value, format = 'YYYY-MM-DD') => {
  if (!value) return value
  return moment(value).format(format)
})

router.beforeEach((to, from, next) => {
  // check login
  if (!store.getters.loggedIn && to.path !== '/login')
    next({ path: '/login', query: { next: to.fullPath } })
  else next()
})
router.onError(err => {
  toast.error('エラーが発生しました。')
})
function getValidationErrors(err) {
  // TODO: 401のtokenのexpireに対応
  let response = err.response
  if (response) {
    if (response.status === 400) {
      let data = response.body || response.data
      return data
    }
  }
  console.warn(err, response)
  return { nonFieldErrors: ['予期しないエラーが発生しました。'] }
}
Vue.prototype.$publicPath = process.env.BASE_URL || '/'
Vue.prototype.$getValidationErrors = getValidationErrors
;(async () => {
  await store.dispatch('refresh')
  store.dispatch('loadStore')
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app')
})()
